<template>
  <Card :bordered="false" class="response-message">
    <Icon type="md-close-circle" size="120" color="#ed4014" class="message-icon" />
    <!--      <h2>Email validation failed</h2><br>-->
    <h4 v-html="message"></h4>
  </Card>
</template>
<script>

  export default {
    name: "PasswordResetFailure",
    data() {
      return {
        message:''
      };
    },
    mounted() {
      if(this.$route.query.hasOwnProperty('message')>-1){
        this.message=this.$route.query.message
      }
    }
  };
</script>
<style scoped>
</style>
